module.exports = __webpack_public_path__ + "static/img/ground3.39649a2b.png";